import * as React from 'react';
import { Theme, withStyles, WithStyles, createStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import { RouteName } from '../../routeNames';
import { localizations } from '../../localization/localization';
import FacebookIcon from "../../images/icon_facebook.png";
import LinkedinIcon from "../../images/icon_linkedin.png";
import TwitterIcon from "../../images/icon_twitter.png";
import EmailIcon from "../../images/icon_email.png";
import HankoPortLogo from "../../images/logos/logo_port_of_hanko.png";
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { push } from 'react-router-redux';

const styles = (theme: Theme) => createStyles({
  footer: {
    padding: '4.6875em',
    paddingTop: '2.75em',
    paddingBottom: '0.375em',
    maxWidth: 1440
  },
  footerContent: {
    borderBottom: '2px solid #033349',
    paddingBottom: '2.6875em',
    '& > div': {
      display: 'flex',
      flexDirection: 'column'
    }
  },
  footerTitle: {
    textTransform: 'uppercase',
    fontWeight: 600,
    marginBottom: '1.6em'
  },
  footerTitleMobile: {
    textTransform: 'uppercase',
    fontWeight: 600,
  },
  footerLinks: {
    height: '3.5em'
  },
  icon: {
    width: '3.25em',
    height: '3.25em'
  },
  linkedinIcon: {
    width: '3.25em',
    height: '3.25em',
    marginLeft: '1.25em',
    marginRight: '1.25em',
    marginTop: '1.1875em'
  },
  newsletterContainer: {
    maxWidth: 500,
    marginLeft: 'auto',
    marginRight: 'auto'
  },
  subscribeButton: {
    fontFamily: 'Roboto',
    marginTop: '1.0714em',
    letterSpacing: '0.03125em'
  },
  footerLink: {
    color: theme.palette.secondary.main,
    marginRight: '1.25em',
    cursor: 'pointer',
    textDecoration: 'underline'
  },
  portLogo: {
    marginTop: '0.75em',
    width: '13.4375em'
  },
  recommendIcon: {
    width: '3.25em',
    height: '3.25em',
    marginRight: '1em',
  },
  recommendIconFacebook: {
    width: '3.25em',
    height: '3.25em',
    marginRight: '1em',
    marginTop: '1em'
  },
  recommendIconMobile: {
    width: '3.25em',
    height: '3.25em',
    marginRight: '1em',
  },
});

function openInNewTab(url: any) {

    const win = window.open(url, '_blank');
    if (win != null){
        win.focus();
    }
}

const Footer: React.SFC<WithStyles & { goToActions: typeof goActions }> = ({
  goToActions,
  classes
}) => {
  const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
  const newsLetterLink = isMobile === true ? 'https://unitspotter.us20.list-manage.com/subscribe?u=0e7490f7241b418427222e933&id=fe09838112' : 'https://www.facebook.com/unitspotter/app/100265896690345/'
  return (
    <Grid item container direction="column" className={classes.footer}>
    <Grid item container>
      <Grid item container className={classes.footerContent}>
        <Grid item>
          <Grid item className={isMobile === false ? classes.footerTitle : classes.footerTitleMobile}>
          {isMobile === true ? <br/> : null}
            {localizations.contact.contactUs}
          </Grid>
          <Grid item>
            <a href="mailto:support@unitspotter.fi" className={classes.footerLink}>
            {localizations.feedback.contact}
            </a>
          </Grid>
          <Grid item>
            <a href="tel:+358102355010" className={classes.footerLink}>
              {localizations.feedback.phone}
            </a>
          </Grid>
          <Grid item>
            <a href="https://www.facebook.com/unitspotter/" target="_blank">
              <img src={FacebookIcon} className={isMobile === false ? classes.recommendIcon : classes.recommendIconMobile} />
            </a>
            <a href="https://www.linkedin.com/company/unitspotter" target="_blank">
              <img src={LinkedinIcon} className={isMobile === false ? classes.recommendIcon : classes.recommendIconMobile}/>
            </a>
            <a href="https://twitter.com/UnitSpotter/" target="_blank">
              <img src={TwitterIcon} className={isMobile === false ? classes.recommendIcon : classes.recommendIconMobile} />
            </a>
          </Grid>
        </Grid>
        <Grid item xs >
          <Grid container direction="column" className={classes.newsletterContainer}>
            {isMobile === true ? <br/> : null}
            <Grid item className={classes.footerTitle}>
            {localizations.footer.recommend}
            </Grid>
            <Grid item>
              <a href="https://www.facebook.com/sharer/sharer.php?u=www.unitspotter.fi" target="_blank">
                <img src={FacebookIcon} className={isMobile === false ? classes.recommendIcon : classes.recommendIconMobile} />
              </a>
              <a href="https://www.linkedin.com/shareArticle?mini=true&url=www.unitspotter.fi&title=UnitSpotter&summary=&source=" target="_blank">
                <img src={LinkedinIcon} className={isMobile === false ? classes.recommendIcon : classes.recommendIconMobile}/>
              </a>
              <a href="https://twitter.com/home?status=Oletko%20miettinyt%20miten%20voisit%20v%C3%A4ltt%C3%A4%C3%A4%20tyhj%C3%A4n%C3%A4%20ajoja%20ja%20parantaa%20kalustosi%20kustannustehokkuutta?%20Tutustu%20sin%C3%A4kin%20UnitSpotteriin,%20ratkaistaan%20t%C3%A4m%C3%A4%20yhdess%C3%A4!%0A%0Ahttps%3A//www.unitspotter.fi%0A%0A%23unitspotter%0A" target="_blank">
                <img src={TwitterIcon} className={isMobile === false ? classes.recommendIcon : classes.recommendIconMobile} />
              </a>
              <a href="mailto:?&subject=UnitSpotter&body=Oletko%20miettinyt%20miten%20voisit%20v%C3%A4ltt%C3%A4%C3%A4%20tyhj%C3%A4n%C3%A4%20ajoja%20ja%20parantaa%20kalustosi%20kustannustehokkuutta?%20Tutustu%20sin%C3%A4kin%20UnitSpotteriin,%20ratkaistaan%20t%C3%A4m%C3%A4%20yhdess%C3%A4!%0A%0Ahttps%3A//www.unitspotter.fi%0A" target="_blank">
                <img src={EmailIcon} className={isMobile === false ? classes.recommendIcon : classes.recommendIconMobile} />
              </a> 
            </Grid>
          </Grid>
        </Grid>
        {isMobile === false ? <br /> : null}
        <Grid item xs>
          <Grid container direction="column" className={classes.newsletterContainer}>
          {isMobile === true ? <br/> : null}
            <Grid item className={classes.footerTitle}>
              {localizations.newsLetter.subscribeToNewsletter}
            </Grid>
            <Grid item>
              {localizations.newsLetter.newsletterDescription}
            </Grid>
            <Grid item>
              <Button
                variant="contained"
                color="secondary"
                className={classes.subscribeButton}
                onClick={() => openInNewTab(newsLetterLink)}
              >
                {localizations.newsLetter.subscribeToNewsletter}
              </Button>
            </Grid>
          </Grid>
        </Grid>  
        <Grid item>
        {isMobile === true ? <br/> : null}
          <Grid item className={classes.footerTitle}>
            {localizations.contact.serviceProvidedBy}
          </Grid>
          <Grid item>
            <a href="https://www.portofhanko.fi" target="_blank">
              <img src={HankoPortLogo} className={classes.portLogo} />
            </a>
          </Grid>
        </Grid>
      </Grid>
      <Grid item container className={classes.footerLinks} alignItems="center">
        <Grid item>
          <a className={classes.footerLink} onClick={() => openInNewTab(RouteName.Privacy)}>
            {localizations.menus.privacyPolicy}
          </a>
        </Grid>
        <Grid item>
          <a className={classes.footerLink} onClick={() => openInNewTab(RouteName.Terms)}>
            {localizations.menus.termsOfService}
          </a>
        </Grid>
        <Grid item>
          <a className={classes.footerLink} onClick={() => goToActions.goTo(RouteName.Media)}>
            {localizations.mediaPageView.linkText}
          </a>
        </Grid>
      </Grid>
    </Grid>
  </Grid>
  );
}

const goActions = {
  goTo: (location: string) => push(location)
};

const mapDispatchToProps = (dispatch: any) => {
  return {
      goToActions: bindActionCreators(goActions, dispatch)
  }
}

export default withStyles(styles)(connect<any, { goToActions: any }>(null, mapDispatchToProps)(Footer));



// WEBPACK FOOTER //
// ./src/landingPage/components/Footer.tsx